import config from '#src/config'

export function relativeToAbsoluteUrl(relativeUrl: string): string {
  const { protocol, host, port } = config.get('consumer')
  const includePort = port.toString() !== '80' && port.toString() !== '443'

  return new URL(relativeUrl, `${protocol}://${host}` + (includePort ? `:${port}` : '')).toString()
}
